import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
  noUsersStyles,
  joinedUsersStyles,
  loadingStyles,
} from './JoinedUsers.styles';
import {
  removeUserFromCircle,
  selectLoadingCircle,
  selectSelectedCircle,
} from '../../redux/store/userData/circles';
import LoadingIcon from '../../components/shared/LoadingIcon';
import { selectToken } from '../../redux/store/userData/user';
import { openModal } from '../../redux/store/ui/common';
import CircleUsersTable from './CircleUsersTable';

const JoinedUsers = () => {
  const dispatch = useDispatch();
  const token = useSelector(selectToken);
  const selectedCircle = useSelector(selectSelectedCircle);
  const loadingCircle = useSelector(selectLoadingCircle);

  const onRemoveUserClicked = (userId: any) => {
    dispatch(removeUserFromCircle(token, selectedCircle?.id!, userId));
  };

  const onAddUserClicked = () => {
    dispatch(openModal('addUserToCircleModal'));
  };

  if (loadingCircle) {
    return (
      <>
        <div className="loading-wrapper">
          <LoadingIcon />
        </div>
        <style jsx>{loadingStyles}</style>
      </>
    );
  }

  return (
    <>
      <div className="add-user-button-wrapper">
        <div
          data-testid="JoinedUsers-addUsersBtn"
          className="add-user-button"
          onClick={onAddUserClicked}
        >
          <p className="button-text">Add user</p>
        </div>
      </div>
      <div
        data-testid="JoindUsers-usersTableWrapper"
        className="record-wrapper"
      >
        <CircleUsersTable
          dataSource={selectedCircle?.users!}
          onRemoveUserClicked={onRemoveUserClicked}
        />
      </div>
      <style jsx>{joinedUsersStyles}</style>
    </>
  );
};

export default JoinedUsers;
